export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sei in modalità Demo. I saldi e le operazioni sono di prova."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vai al cabinet di lavoro"])}
}